import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonUtil } from '../Utils/common-util';

@Component({
  selector: 'app-btn-dynamic',
  templateUrl: './btn-dynamic.component.html',
  styleUrls: ['./btn-dynamic.component.scss']
})
export class BtnDynamicComponent implements OnInit {
  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  @Input() btnLabel: string;
  @Input() isDisabled: string;
  @Input() btnType:string;
  @Input() count:number;


  constructor(
    public _commonUtil: CommonUtil
  ){}

  ngOnInit(): void {
    this.btnLabel = this._commonUtil.translateText(this.btnLabel);
  }

  onBtnClick(): boolean {
    if (this.isDisabled === 'true') {
      return false;
    }
  
    // alert('clicked btn in child component');
    this.callOnClick.emit();
    return true;
  }

}
